import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "transcript-poll" };
const _hoisted_2 = ["innerHTML"];
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = { class: "transcript-poll__results" };
const _hoisted_5 = { class: "transcript-poll__choice-head" };
const _hoisted_6 = ["innerHTML"];
const _hoisted_7 = {
    key: 0,
    class: "transcript-poll__choice-stats"
};
const _hoisted_8 = { class: "transcript-poll__bar" };
const _hoisted_9 = {
    key: 0,
    class: "transcript-poll__respondents"
};
const _hoisted_10 = ["src", "alt"];
export default /*@__PURE__*/ _defineComponent({
    __name: 'TranscriptPoll',
    props: {
        poll: {}
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", {
                    class: "transcript-poll__question",
                    innerHTML: __props.poll.question
                }, null, 8, _hoisted_2),
                (__props.poll.instructions)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "transcript-poll__instructions",
                        innerHTML: __props.poll.instructions
                    }, null, 8, _hoisted_3))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_4, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.poll.choices, (choice) => {
                        return (_openBlock(), _createElementBlock("div", {
                            key: choice.id,
                            class: _normalizeClass(["transcript-poll__choice", { 'transcript-poll__choice--skipped': choice.skipped }])
                        }, [
                            _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("span", {
                                    class: "transcript-poll__choice-label",
                                    innerHTML: choice.value
                                }, null, 8, _hoisted_6),
                                (choice.count > 0)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                                        _createElementVNode("strong", null, _toDisplayString(choice.count), 1),
                                        _createTextVNode(" (" + _toDisplayString(choice.percent) + "%) ", 1)
                                    ]))
                                    : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_8, [
                                _createElementVNode("div", {
                                    class: "transcript-poll__bar-fill",
                                    style: _normalizeStyle({ width: `${choice.percent}%` })
                                }, null, 4)
                            ]),
                            (choice.respondents.length)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(choice.respondents, (respondent, index) => {
                                        return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                            (respondent.photo)
                                                ? (_openBlock(), _createElementBlock("img", {
                                                    key: 0,
                                                    class: "transcript-poll__respondent",
                                                    src: respondent.photo,
                                                    alt: respondent.name ?? ''
                                                }, null, 8, _hoisted_10))
                                                : _createCommentVNode("", true)
                                        ], 64));
                                    }), 128))
                                ]))
                                : _createCommentVNode("", true)
                        ], 2));
                    }), 128))
                ])
            ]));
        };
    }
});
